<template>
  <nav class="navbar">
    <div class="navbar-container">
      <div class="navbar-logo">
        <img src="@/assets/logo.png" alt="OPEditor Logo">
        <h1>灵易智模数据统计</h1>
      </div>
      <div class="navbar-links">
        <router-link to="/" exact-active-class="active">首页</router-link>
        <router-link to="/user-details" active-class="active">用户详情</router-link>
        <router-link to="/action" active-class="active">功能使用</router-link>
      </div>
      <div class="navbar-user">
        <span v-if="isLoggedIn">
          已登录
          <button class="logout-btn" @click="logout">退出</button>
        </span>
        <span v-else>
          <button class="login-btn" @click="$emit('show-login')">登录</button>
        </span>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('token');
      this.$emit('logout');
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.navbar-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  max-width: 1600px;
  margin: 0 auto;
}

.navbar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 40px;
}

.navbar-logo img {
  height: 32px;
  width: auto;
}

.navbar-logo h1 {
  margin: 0;
  font-size: 20px;
  color: #303133;
}

.navbar-links {
  display: flex;
  gap: 20px;
  margin-right: auto;
}

.navbar-links a {
  color: #606266;
  text-decoration: none;
  padding: 6px 12px;
  border-radius: 4px;
  transition: all 0.3s;
}

.navbar-links a:hover {
  color: #409EFF;
  background-color: #ecf5ff;
}

.navbar-links a.active {
  color: #409EFF;
  background-color: #ecf5ff;
}

.navbar-user {
  display: flex;
  align-items: center;
}

.login-btn, .logout-btn {
  margin-left: 10px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.login-btn {
  background-color: #409EFF;
  color: white;
}

.login-btn:hover {
  background-color: #66b1ff;
}

.logout-btn {
  background-color: #f56c6c;
  color: white;
}

.logout-btn:hover {
  background-color: #f78989;
}

@media (max-width: 768px) {
  .navbar-container {
    padding: 0 10px;
    justify-content: flex-start;
  }
  
  .navbar-logo {
    margin-right: 20px;
  }
  
  .navbar-logo h1 {
    font-size: 16px;
  }
  
  .navbar-links {
    gap: 10px;
  }
  
  .navbar-links a {
    padding: 4px 8px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .navbar-container {
    flex-wrap: wrap;
    height: auto;
    padding: 10px;
  }
  
  .navbar-logo {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }
  
  .navbar-links {
    width: 100%;
    justify-content: center;
    margin-bottom: 10px;
  }
  
  .navbar-user {
    width: 100%;
    justify-content: center;
  }
}
</style> 